<template>
  <v-container fluid class="batchpayment-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="8" class="d-flex flex-start justify-md-start">
              <v-btn color="success" class="button-shadow mr-2" @click="isFindBatchPayment=true">
                <v-icon class="mr-0">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn to="/bill/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-0">mdi-file-multiple</v-icon>
                Bills
              </v-btn>
              <v-btn to="/purchaseorder/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-0">mdi-file-multiple</v-icon>
                Purchases
              </v-btn>
              <v-btn to="/fabill/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-0">mdi-file-multiple</v-icon>
                FA Bills
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              sort-desc
              item-key="_id"
              v-model="seletected_payments"
              loading-text="Loading... Please wait"
              class="batchpayments-table"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="header_payments"
              :items="data_payments"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteBatchPayment"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Batch Payment?
                    </v-card-title>

                    <v-card-text>
                      {{ delete_payment.paymentnum }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteBatchPayment = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteBatchPayment(delete_payment)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.userid="{ item }">
                <div v-if="item.userid!=undefined">
                <v-avatar v-if="users.length>0 && users.find(user=>user._id == item.userid)['userimage']!==''" size="40">
                  <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <span class="white--text headline">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'][0].toUpperCase() : '' }}</span>
                </v-avatar>
                <span style="margin-left:15px">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </span>
                </div>
              </template>
              
              <template v-slot:item.transactions="{ item }">
                {{ getUniqueNames(item)}}
              </template>
              <template v-slot:item.paymentnum="{ item }">
                <p class="two-line">{{ item.paymenttype  }} {{ item.paymentnum  }}</p>
                <p v-if="item.paymentdate!=undefined" class="two-line">{{ new Date(item.paymentdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.locationid="{ item }">
                <p class="two-line">{{ locations.length>0 && locations.find(location=>location._id == item.locationid)!=null ? locations.find(location=>location._id == item.locationid)['locationname'] : '' }}</p>
                <p class="two-line">{{ accounts.length>0 && accounts.find(account=>account._id == item.accountid)!=null ? accounts.find(account=>account._id == item.accountid)['accountcode'] : '' }}</p>
              </template>
              <template v-slot:item.paymenttotal="{ item }">
                <p class="two-line">{{ item.paymenttotal.toLocaleString('en-SG') }} {{primaryCurrency}}</p>
                <p v-if="isDualCurrency==true" class="two-line">{{ (item.paymenttotal * currencyRate).toFixed(0) }} {{secondaryCurrency}}</p>
              </template>
              <template v-slot:item.approvalidnum="{ item }">
                <div v-if="item.approvalidnum!=null">
                  <p class="two-line" style="margin-left: 5px;">
                    <v-avatar v-if="item.approvalimage!=null && item.approvalimage!=''" size="40">
                      <img v-bind:src="item.approvalimage" alt="">
                    </v-avatar>
                  </p>
                <p class="two-line"><span style="margin-left:5px">{{ item.approvalname }} </span></p>
                </div>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.paymentstatus="{ item }">
                <v-chip
                  v-if="item.paymentstatus!=undefined"
                  :color="getStatusColor(item.paymentstatus)" small>
                  {{ item.paymentstatus }}
                </v-chip>
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=null">
                  <v-btn v-if="item.paymentstatus=='New'" icon color="primary" @click="updatePaymentPendingDialog(item)">
                    <v-icon>mdi-account-edit</v-icon>
                  </v-btn>
                  <v-btn v-if="item.paymentstatus!='Completed'" icon color="primary" @click="updatePaymentConfirmDialog(item)">
                    <v-icon>mdi-text-box-edit</v-icon>
                  </v-btn>
                  <v-btn icon color="primary" @click="editItem(item)">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                  <v-btn v-if="item.paymentstatus=='New'" icon color="primary" @click="deleteBatchPaymentDialog(item)">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                  <v-btn icon color="primary" @click="printItem(item)">
                    <v-icon>mdi-printer</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="isFindBatchPayment"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find Payments</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="locations.filter(x=>x.locationstatus=='Active').map(x => {
                              return {text: x.locationname, value: x._id};
                            })"
                    v-model="find_query.locationid"
                    label="Location"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="data_accounts"
                    v-model="find_query.accountid"
                    label="Payment From Account"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    :items="['New', 'Pending', 'Partial', 'Completed', 'Audit', 'Void']"
                    v-model="find_query.paymentstatus"
                    label="Payment Status"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    class="mb-4"
                    type="number"
                    placeholder="Payment Num"
                    v-model="find_query.paymentnum"
                    dense
                    oninput="if(this.value < 1) this.value = 1;"
                    single-line hint="Payment Num">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                          <v-menu
                            ref="menu_startdate"
                            v-model="menu_startdate"
                            :close-on-content-click="false"
                            :return-value.sync="find_query.startdate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                v-model="find_query.startdate"
                                label="Start Date"
                                v-bind="attrs"
                                v-bind:value="find_query.startdate"
                                v-on="on"
                                persistent-hint
                                single-line hint="Please enter start date">
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="find_query.startdate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu_startdate = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu_startdate.save(find_query.startdate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                          <v-menu
                            ref="menu_enddate"
                            v-model="menu_enddate"
                            :close-on-content-click="false"
                            :return-value.sync="find_query.enddate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                v-model="find_query.enddate"
                                label="End Date"
                                v-bind="attrs"
                                v-bind:value="find_query.enddate"
                                v-on="on"
                                persistent-hint
                                single-line hint="Please enter end date">
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="find_query.enddate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu_enddate = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu_enddate.save(find_query.enddate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFindBatchPayment = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetBatchPayments"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findBatchPayments"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <v-dialog
        v-model="isApproveSend"
        persistent
        width="400px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Send for Approval</span>
            </v-card-title>
            <v-card-text>
              {{ approve_send.paymenttype }} {{ approve_send.paymentnum }}
            </v-card-text>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="approve_send.confirm"
                      required
                      dense
                      persistent-hint
                      single-line hint="Type the word 'Send'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isApproveSend=false; approve_send={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="approve_send.confirm!=='Send'"
                @click="updatePaymentPending"
              >
                Send
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog
        v-model="isConfirmSend"
        persistent
        width="400px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Confirm Payment</span>
            </v-card-title>
            <v-card-text>
              {{ approve_send.paymenttype }} {{ approve_send.paymentnum }}
            </v-card-text>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="confirm_send.confirm"
                      required
                      dense
                      persistent-hint
                      single-line hint="Type the word 'Confirm'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isConfirmSend=false; confirm_send={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="confirm_send.confirm!=='Confirm'"
                @click="updatePaymentConfirm"
              >
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'
import { getStatusColor } from '../../../util/tools';

export default {
  name: 'BatchPaymentList',
  data() {
    return {
      config,
      isFindBatchPayment: false,
      isApproveSend: false,
      isConfirmSend: false,
      isDeleteBatchPayment: false,
      menu_startdate: null,
      menu_enddate: null,
      itemPerPage: 500,
      isDualCurrency: false,
      primaryCurrency: null,
      secondaryCurrency: null,
      currencyRate: null,
      find_query: {},
      delete_payment: {},
      approve_send: {},
      confirm_send: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      header_payments: [
        { text: 'Payment', value: 'paymentnum', sortable: false, width: '15%' },
        { text: 'Location', value: 'locationid' },
        //{ text: 'Names', value: 'transactions'},
        { text: 'Amount', value: 'paymenttotal', width: '12%' },
        { text: 'Approval', value: 'approvalidnum', width: '12%' },
        { text: 'Status', value: 'paymentstatus', width: '10%' },
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      data_payments: [],
      seletected_payments: [],
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('BatchPayment', ['batchpayments', 'query', 'isReceiving', 'isDeleting', 'idToDelete', 'batchpaymentsMessage', 'isUpdating']),
    ...mapState('Location', ['locations']),
    ...mapState('SystemSetting', ['settings']),
    ...mapState('User', ['users']),
    ...mapState('Vendor', ['vendors']),
    data_accounts(){
      let result = this.accounts.filter(account=>account.accountsubclass=='Bank');
      let filter = this.accounts.filter(account=>account.accountname.includes('Accounts Receivable'));
      let results = [...result, ...filter];
      return results.map(x => { return {text: x.accountname, value: x._id} });
    },
  },
  methods: {
    ...mapActions('Account', ["getAccountsRequest"]),
    ...mapActions('BatchPayment', ["getBatchPaymentsRequest", "findBatchPaymentsQueryRequest", "updateBatchPaymentPendingRequest", "updateBatchPaymentConfirmRequest", "deleteBatchPaymentRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('SystemSetting', ["getSetting", "getSystemSettingsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    ...mapActions('Vendor', ["getVendorsRequest"]),
    getJson(item){
      let jsons = [];
      for(var i in item.transactions){
        let payment_data;
        let trans = item.transactions[i];
        let vendor = this.vendors.find(vendor=>vendor._id==trans.vendorid);
        if(vendor!=null && vendor.options!=null && vendor.options.paymentdata!=""){
          let json_string = vendor.options.paymentdata;
          let ref_num = trans.refnum!='' ? trans.refnum : 'Bill ' + trans.transnum.toString()
          json_string = json_string.replace("${payment_amount}", trans.transamount.toFixed(2));
          json_string = json_string.replace("${reference_number}", ref_num);
          payment_data = JSON.parse(json_string);
        }
        else {
          payment_data = {};
        }
        jsons.push(payment_data);
      }

      console.log(jsons)
      return jsons;
    },
    getFileName(){
      var d = new Date();
      var name = 'batch-payment-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.csv';
    },
    getUniqueNames(item){
      let trans = item.transactions.map(item=>item.transname.toString());
      let set = new Set(trans);
      let result = Array.from(set)
      result = result.join(', ') 
      return result;
    },
    editItem(item) {
      this.$router.push({ name: 'BatchPaymentEdit', params: item });
    },
    printItem(item) {
      item['_isFrom'] = this.$route.name;
      this.$router.push({ name: 'BatchPaymentPrint', params: item });
    },
    updatePaymentConfirmDialog(item) {
      this.isConfirmSend = true;
      this.confirm_send = {
        _id: item._id,
        paymentnum: item.paymentnum,
        paymenttype: item.paymenttype,
      };
    },
    updatePaymentPendingDialog(item) {
      this.isApproveSend = true;
      this.approve_send = {
        _id: item._id,
        paymentnum: item.paymentnum,
        paymenttype: item.paymenttype,
      };
    },
    async updatePaymentPending() {
      this.isApproveSend = false;
      let result = await this.updateBatchPaymentPendingRequest(this.approve_send);
      let index = this.data_payments.findIndex((x) => x._id == result._id);
      this.data_payments.splice(index, 1, result);
      this.approve_send = {};
    },
    async updatePaymentConfirm() {
      this.isConfirmSend = false;
      console.log(this.confirm_send);
      let result = await this.updateBatchPaymentConfirmRequest(this.confirm_send);
      let index = this.data_payments.findIndex((x) => x._id == result._id);
      this.data_payments.splice(index, 1, result);
      this.confirm_send = {};
    },
    deleteBatchPaymentDialog(item) {
      this.isDeleteBatchPayment = true;
      this.delete_payment = {_id: item._id, paymentnum: item.paymentnum}
    },
    async deleteBatchPayment(item) {
      this.isDeleteBatchPayment = false;
      await this.deleteBatchPaymentRequest(item);
      this.data_payments = Object.assign([], this.batchpayments);
    },
    async findBatchPayments(){
      this.isFindBatchPayment = false;
      if(Object.keys(this.find_query).length==0){
        await this.getBatchPaymentsRequest();
        this.data_payments = Object.assign([], this.batchpayments);
      }
      else{
        let result = await this.findBatchPaymentsQueryRequest(this.find_query);
        this.data_payments = Object.assign([], result);
      }
    },
    async resetBatchPayments(){
      this.find_query = {};
    },
  },
  async created () {
    if(Object.keys(this.query).length==0){
      if(this.batchpayments.length==0) await this.getBatchPaymentsRequest();
      this.data_payments = Object.assign([], this.batchpayments);
    }
    else {
      this.find_query = Object.assign({}, this.query)
      let result = await this.findBatchPaymentsQueryRequest(this.query);
      this.data_payments = Object.assign([], result);
    }

    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.settings.length==0) await this.getSystemSettingsRequest();
    if(this.users.length==0) await this.getUsersRequest();
    if(this.vendors.length==0) await this.getVendorsRequest();
    
    this.primaryCurrency = await this.getSetting({code: 'CurrencySettings', name: 'PrimaryCurrency'}, );
    this.secondaryCurrency = await this.getSetting({code: 'CurrencySettings', name: 'SecondaryCurrency'}, );
    this.currencyRate = await this.getSetting({code: 'CurrencySettings', name: 'DefaultCurrencyRate'}, );
    this.isDualCurrency = this.primaryCurrency!=null && this.secondaryCurrency!=null ? (this.primaryCurrency!=this.secondaryCurrency) : false;
  },
}
</script>

<style src="./List.scss" lang="scss"></style>